import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAddOn } from './interfaces.types';
import { Attachment, ILead, IPendingPaymentDTO } from './shared-interface.types';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {
  private proxyUrl = environment.baseUrl;
  private intergrationUrl = environment.integrationUrl;
  public activeCustomerServices: any;
  public debitOrderMandateData: any;
  public customerPaymentMethod: any;
  public debitOrdersArray: any;
  public debitOrderMandateDetailsArray: any;
  private integrationUrl = environment.integrationUrl;
  constructor(private _http: HttpClient) {
  }


  // ---------------------------------------------------------- //
  // ===================== CUSTOMER DETAILS ====================//
  // ---------------------------------------------------------- //
  public downloadStatement(statementID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=entityaccountstatementhistory/${statementID}/pdf?extract=true`, {responseType: 'blob'})
  }

  public getInvoiceById(id: number) {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/invoices/${id}/pdf`, {responseType: 'blob'});
  }

  public getCustomerStatements(entityAccountID: number, status: string) {
    return this._http.get(`${this.proxyUrl}/service?url=odata/entityaccountstatementhistoryodata?entityAccountID=${entityAccountID}&status=${status}`)
  }

  public emailStatement(entityAccountID: number, statementID: number, fromDate: any, toDate: any) {
    const body = {
      Data: {
        FromDate: fromDate,
        ToDate: toDate,
        PreviewOnly: true
      },
      Url: 'endcustomer/customeraccount/' + entityAccountID + '/statement/' + statementID + '/pdf/email',
    }
    if(statementID){
      return this._http.post(`${this.proxyUrl}/service?url=endcustomer/account/${entityAccountID}/statement/${statementID}/pdf/email`, body)
    }else{
      body.Url = 'endcustomer/customeraccount/' + entityAccountID + '/statement/pdf/email'
      return this._http.post(`${this.proxyUrl}/service?url=endcustomer/account/${entityAccountID}/statement/pdf/email`, body)
    }
    
  }

  public generateStatement(fromDate: any, toDate: any, entityAccountID) {

    const body = {
      Data: {
        FromDate: fromDate,
        ToDate: toDate,
        PreviewOnly: true
      },
      Url: 'customers/' + entityAccountID + '/statement/pdf/email'
    }
    return this._http.post(`${this.proxyUrl}/service`, body)
    // return this._http.post(`${this.proxyUrl}/service?url=endcustomer/statements`, body)
  }

  public getCustomerAccount() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/account`);
  }

  public getCustomerInvoices() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/invoices`)
  }

  public getCustomerPayments() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/paymentmethods`);
  }

  public getCustomerBillingItems() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/allservices`)
  }

  public getCustomerLeads() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/openleads`)
  }

  public getCustomerActiveServices() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/activeservices`)
  }
  public getCustomerBalance(entityAccountID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/${entityAccountID}/balance`)
  }
  

  public updateCustomerAccount(customerAccount: any) {
    const data = {
      Data: customerAccount,
      Url: 'endcustomer/account'
    }
    return this._http.put(`${this.proxyUrl}/service?url=endcustomer/account`, data)
  }

  //Link Account to Lead
  public linkAccountToLead (leadId: any, accountId: any) {
    const data = {
      Url: 'lead/' + leadId + '/customerAccount/' + accountId
    }
    return this._http.post(`${this.proxyUrl}/service?url=lead/${leadId}/customerAccount/${accountId}`, data)
  }

  //Get Radius usage
  public getCustomerRadiusUsage (serviceAccountEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=serviceaccounts/${serviceAccountEntityID}/radiusserver/overview`)
  }

  public getCustomerRadiusActions (serviceAccountEntityID: number, key: string, aggregation?: string) {
    const data = {
      Data :{
        aggregation
      },
      Url: `serviceaccounts/${serviceAccountEntityID}/radiusserver/actions/execute?actionKey=${key}`
    }
    return this._http.post(`${this.proxyUrl}/service`, data)
  }


  // ---------------------------------------------------------- //
  // ===================== DEBIT ORDERS ========================//
  // ---------------------------------------------------------- //

  public changeDebitOrderDate(account: object){
    const body = {
      Url: 'endcustomer/account',
      Data: {
        ...account
      }
    }
    return this._http.put(`${this.proxyUrl}/service`, body)
  }



  public getDebitOrderMandateStatus(leadId: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${leadId}/debitordermandaterequired`)
  }


  public isDebitOrderRequired(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/debitordermandaterequired`)
  }

  public generateDebitOrderMandate(leadEntityID: number, entityAccountID: number, debitAmount: number, paymentMethod: any) {
    var CreateDefaultPaymentMethod = false;
    const customerPayments = this.getCustomerPayments().subscribe((customerPayments: any) => {
      const latestPaymentDetails = customerPayments?.find(
        (element) => element.IsDefault === true && element.IsValidated
      );

      CreateDefaultPaymentMethod = !(latestPaymentDetails.BankAccountNumber === paymentMethod.BankAccountNumber);

      const defaultPayment = customerPayments.find(pm => pm.IsDefault === true);

      if (defaultPayment && !defaultPayment.IsValidated) {
        Swal.fire({
          title: 'Error!',
          text: 'No valid payment method provided!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          customClass: {
            htmlContainer: 'text-lg',
            confirmButton: 'custom-button text-md text-black',
          }
        });

        return;
      }
    });

    const body = {
      Url: 'debitordermandate/generate?isInternal=true',
      Data: {
        LeadEntityID: leadEntityID,
        EntityAccountID: entityAccountID,
        DebitAmount: debitAmount,
        CreateDefaultPaymentMethod: CreateDefaultPaymentMethod,
        DefaultPaymentMethod: {
          PaymentMethod: paymentMethod?.PaymentMethod,
          PaymentMethodName: paymentMethod?.PaymentMethodName,
          BankAccountName: paymentMethod.BankAccountName.slice(0, 30),
          BankAccountType: paymentMethod.BankAccountType,
          BankAccountTypeName: paymentMethod.BankAccountType,
          BankAccountBranchCode: paymentMethod.BankAccountBranchCode,
          BankAccountNumber: paymentMethod.BankAccountNumber,
          IsDefault: true,
          BankName: paymentMethod.BankName
        }
      }
    }
    return this._http.post(`${this.proxyUrl}/service`, body)
  }

  public getDebitOrder(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/debitordermandates/list`)
  }

  public rejectDebitOrder(EntityAccountDebitOrderMandateID: number) {
    const data = {
      Url: 'debitordermandate/' + EntityAccountDebitOrderMandateID + '/reject'
    }
    return this._http.post(`${this.proxyUrl}/service`, data)
  }

  public acceptDebitOrderOTP(EntityAccountDebitOrderMandateID: number) {
    const data = {
      Url: 'debitordermandate/' + EntityAccountDebitOrderMandateID + '/request_otp?isInitiate=false&isAuthorise=true'
    }
    return this._http.post(`${this.proxyUrl}/service`, data)
  }

  public getLatestPendingDO() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/pendingdebitordermandate`)
  }

  public authoriseMandateWithOTP(EntityAccountDebitOrderMandateID: number, OTP: number) {
    const data = {
      Url: 'debitordermandate/' + EntityAccountDebitOrderMandateID + '/authorise_accept_mandate',
      Data: {
        AuthorisedOTP: OTP
      }
    }
    return this._http.post(`${this.proxyUrl}/service`, data)
  }


  public cancelDebitOrder(LeadEntityId: number, reason: any, comment) {
    const data = {
      Url: `endcustomer/leads/${LeadEntityId}/cancel?cancellationReasonID=${reason.CancellationReasonID}&cancellationNotes=${comment}`,
      Data: {}
    }
    return this._http.put(`${this.proxyUrl}/service`, data)
  }

  public getRegradeOptions(accountofferableEntityId: number, actionType: string) {
    return this._http.get(`${this.proxyUrl}/service?url=accountofferable/${accountofferableEntityId}/regradeconfig?actionType=${actionType}`)
  }



  // ---------------------------------------------------------- //
  // ===================== BANK DETAILS ========================//
  // ---------------------------------------------------------- //
  public getBankList() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/paymentmethods/banks`)
  }

  public getBankAccountTypeList() {
    return this._http.get(`${this.proxyUrl}/service?url=accountpaymentmethods/bankaccounttypes`)
  }

  public getDebitOrderCollectionRuns() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/debitordercollectionruns`)
  }


  // ---------------------------------------------------------- //
  // ==================== PAYMENT METHODS=======================//
  // ---------------------------------------------------------- //
  public addPaymentMethods(paymentMethodPayload: any) {

    const dto = {
      Url: 'endcustomer/paymentmethods',
      Data: paymentMethodPayload
    }
    return this._http.post(`${this.proxyUrl}/service`, dto)
  }

  public getPaymentMethods() {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/paymentmethods`)
  }

  public previewDebitOrderMandate(entityAccountDebitOrderMandateID: number, token: string) {
    return `${this.proxyUrl}/service?inlinePdf=true&url=debitordermandate/${entityAccountDebitOrderMandateID}/pdf?Token=${token}`

  }

  // public generatePendingReceiptForLead(pendingReceiptPayload: any, token: string) {

  //   const headers = {
  //     'Content-Type': 'application/json',
  //     ClientCode: process.env.JILClientCode,
  //     Authorization: token
  //   }
  //   const data = {
  //     Data: pendingReceiptPayload,
  //     Url: 'endcustomer/pending_payment'
  //   }

  //   return this._http.post(`${this.proxyUrl}/service?url=endcustomer/pending-payment`, data, {headers})
  // }


  // ---------------------------------------------------------- //
  // ==================== TICKETS =======================//
  // ---------------------------------------------------------- //


  public getTicketTopics() {
    return this._http.get(`${this.proxyUrl}/service?url=TicketTopics?publicOnly=true`)
  }
  public createTicket(ticketData: any) {
    const data = {
      Url: "endcustomer/tickets/withoutattachments",
      Data: {
        CustomerName: ticketData.CustomerName,
        CustomerEmailAddress: ticketData.CustomerEmailAddress,
        CustomerMobileNumber: ticketData.CustomerMobileNumber,
        Subject: ticketData.Subject,
        Description: ticketData.Description,
        TopicId: ticketData.TopicId
      }
    }
    return this._http.post(`${this.proxyUrl}/service`, data)
  }

    // GET ALL TICKETS
    // public getAllTickets() {
    //   return this._http.get(`${this.integrationUrl}/odata/ticketsodata?elasticSearch=&tags=&roles=&Elastic=false&ElasticField=false&ElasticFieldValue=false&myTickets=false&myTicketsToggle=false&trash=false&%24top=20&%24count=true`)
    // }

    public getAllTickets() {
      return this._http.get(`${this.proxyUrl}/service?url=endcustomer/tickets`)
    }

    // GET ALL MESSAGES
    public getAllTicketMessages(id) {
      return this._http.get(`${this.proxyUrl}/service?url=endcustomer/tickets/externalcomments/${id}`)
    }

    // SEND TICKET MESSAGE
   public sendTicketMessage(ticketNumber: number, message:string) {

    const formData = new FormData();
    const model =  {
      IsInternal: false,
      Text: message,
      TicketId: ticketNumber
    };
    formData.append("model", JSON.stringify(model))
    
    return this._http.post(`${this.integrationUrl}/ticket/${ticketNumber}/comment`, formData)
  }

  // ---------------------------------------------------------- //
  // ======================== PACKAGES =========================//
  // ---------------------------------------------------------- //

  public getAvailablePackages(leadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/availablepackages?LeadEntityID=${leadEntityID}`)
  }

  public getPackageByID(PackageEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=packages/${PackageEntityID}`)
  }

  public getLinkedOfferablesByLeadId(leadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=entitylinkedofferable/list/${leadEntityID}`);
  }

  public removeSalesItemsFromLead(LeadEntityID: number) {
    return this._http.delete(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/remove_all_sales_items`)
  }

  public addPackageToLead(LeadEntityID: number, PackageEntityID: number) {   
    const data = {
      Data: {
        Packages: [{PackageEntityID: PackageEntityID}]
      },
      Url: 'lead/' + LeadEntityID + '/packages'
    }
    return this._http.post(`${this.proxyUrl}/service?url=packages`, data)
  }

  public getAppliedPromoCode(leadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=leads/${leadEntityID}/appliedpromocode`);
  }

  public applyPromoCode(LeadEntityID: number, PromoCode: string) {

    const data = {
      Url: 'leads/' + LeadEntityID + '/promocode/' + PromoCode
    }
    return this._http.post(`${this.proxyUrl}/service`, data)
  }

  public getPromoSalesItems(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/sales_items`)
  }

  public getAddons(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/availability/addons`)
  }

  public addAddOnToLead(addOn: IAddOn) {
    const data = {
      Data: addOn,
      Url: `entitylinkedofferable`
    }
    return this._http.post(`${this.proxyUrl}/service`, data);
  }

  public getTermsAndConditions(PackageEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=packages/${PackageEntityID}/termsandconditions`)
  }

  public getGlobalTermsAndConditions() {
    return this._http.get(`${this.proxyUrl}/service?url=termsandconditionstemplate/list`)
  }

  public acceptTermsAndConditions(LeadEntityID: number, TermsAndConditionsTemplateID: number) {

    const data = {
      Url: 'acceptedterms',
      Data: {
        LeadEntityID: LeadEntityID,
        TermsAndConditionsTemplateID: TermsAndConditionsTemplateID
      }
    }

    return this._http.post(`${this.proxyUrl}/service?url=acceptedterms`, data)
  }

  public setLeadActionType(LeadEntityID: any, orderType: string) {
    const data = {
      Url: `lead/${LeadEntityID}/leadActionType/${orderType}`
    }
    return this._http.post(`${this.proxyUrl}/service?url=lead`, data);
  }

  public getAllPackages() {
    return this._http.get(`${this.proxyUrl}/service?url=odata/packagesodata`);
  }

  // ---------------------------------------------------------- //
  // =================Special Products========================= //
  // ---------------------------------------------------------- //

  public packageCompletionValidate(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/leads/${LeadEntityID}/completion/validate`);
  }

  public executeSpecialProductAction(LeadEntityID: number, SalesEntityItemId: number, ActionKey: string, actionPayload: any) {
    const data = {
      Url: `endcustomer/leads/${LeadEntityID}/sales_items/${SalesEntityItemId}/specialproduct/actions/execute?actionKey=${ActionKey}`,
      Data: actionPayload
    }

    return this._http.post(`${this.proxyUrl}/service`, data);
  }

  public getSpecialProductOverview(LeadEntityID: number, SalesEntityId: number) {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/leads/${LeadEntityID}/sales_items/${SalesEntityId}/specialproduct/overview?callerContext=EndCustomer`);
  }

  public cancelSpecialProductOverview(entityAccountOfferableEntityID: number, actionKey: string) {
    const data = {
      Url: `endcustomer/activeitems/${entityAccountOfferableEntityID}/specialproduct/actions/execute?actionKey=${actionKey}`,
    }
    return this._http.post(`${this.proxyUrl}/service`, data);

  }

  public executeSpecialProductSubAction(LeadEntityID: number, SalesEntityId: number, ActionKey: string, SubActionKey: string, actionPayload: any) {
    const data = {
      Url: `endcustomer/leads/${LeadEntityID}/sales_items/${SalesEntityId}/specialproduct/actions/execute?actionKey=${ActionKey}/${SubActionKey}`,
      Data: actionPayload
    }
    return this._http.post(`${this.proxyUrl}/service`, data);
  }

  public requiresAddressVerification(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/requires_address_verification`);
  }

  public getAddressVerification(LeadEntityID: number, address: string) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/verification_addresses?search=${address}`);
  }

  
  // ---------------------------------------------------------- //
  // ======================== LEADS =========================== //
  // ---------------------------------------------------------- //

  public getLeadById(LeadEntityID: any) {
    return this._http.get(`${this.proxyUrl}/lead/${LeadEntityID}`);
  }

  public generateLead(offerableID: number, type: string, leadDescription?: string) {
    const dto = {
      Audit_IsActive: false,
      AutoGenerateCollaborators: true,
      Fibre_Feasibility_DoTest: true,
      IsFeasibilityLead: true,
      LeadActionTypeCode: type,
      LeadSource: 'PUBLIC',
      Microwave_Feasibility_DoTest: true,
      Mobile_Feasibility_DoTest: true,
      UpdatingEntityAccountOfferableID: offerableID,
      LeadDescription: type ? type : null
    }
    return this._http.post(`${this.proxyUrl}/lead`, dto)
  }

  public getLeadCustomStatuses() {
    return this._http.get(`${this.proxyUrl}/service?url=organisationleadstatuses`)
  }

  public updateLeadWithCustomStatus(leadEntityId: number, id: number) {
    const data = {
      Url: `lead/${leadEntityId}/updatecustomstatus/${id}`,
      Data: {}
    }
    return this._http.put(`${this.proxyUrl}/service`, data)
  }
  
  public customerDetailsUpdate(leadEntityId: number, contactableName: string, contactableSurname: string, contactablePhoneNumber: number) {
    const data = {
      Url: `lead/${leadEntityId}/updateCustomerDetails`,
      Data: {
        LeadContactName: contactableName,
        LeadContactSurname: contactableSurname,
        LeadContactNumber: contactablePhoneNumber
      }
    }
    return this._http.put(`${this.proxyUrl}/service`, data)
  }

  public updateLeadSourceCode(leadEntityId: number, leadSourceCodeId: number) {
    const data = {
      Url: `/lead/${leadEntityId}/updateleadsource/?leadSourceId=${leadSourceCodeId}`,
      Data: {}
    }
    return this._http.put(`${this.proxyUrl}/service`, data)
  }

  public getLeadSource() {
    return this._http.get(`${this.proxyUrl}/service?url=leadsource/list`)
  }

  public feasability(data: any) {
    return this._http.post(`${this.proxyUrl}/lead`, data)
  }

  public updateLead(lead: ILead) {
    return this._http.post(`${this.proxyUrl}/lead`, lead)
  }

  public cancelLeadById(LeadEntityID: any) {
    const data = {
      Url: `lead/${LeadEntityID}/cancel`
    }
    return this._http.put(`${this.proxyUrl}/service`, data);
  }


  // ---------------------------------------------------------- //
  // ======================== Services =========================//
  // ---------------------------------------------------------- //
  public getCancelationReasonOData() {
    return this._http.get(`${this.proxyUrl}/service?url=leads/cancellationreasons?context=LeadCancellation`)
  }

  public serviceCancellationReasons() {
    return this._http.get(`${this.proxyUrl}/service?url=leads/cancellationreasons?context=ServiceCancellation`)
  }


  public cancelService(data: any) {
    return this._http.post(`${this.proxyUrl}/lead`, data)
  }

  // ---------------------------------------------------------- //
  // ======================= PAYMEMNTS =========================//
  // ---------------------------------------------------------- //

  public getUpfrontAmountDue(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=lead/${LeadEntityID}/upfrontpaymentamountdue`);
  }

  public generatePendingPayment(DTO: IPendingPaymentDTO) {
    
    const payload = {
      LeadEntityID: DTO.leadEntityId ?? null,
      IsPendingPayment: true,
      PendingAmount: DTO.pendingAmount,
      EntityAccountID: DTO.entityAccountID,
      Allocations: DTO.isPartialPayment ?? DTO.pendingAmount,
      IsForCardTokenisation: DTO.isForCardTokenisation,
      AccountReceiptPaymentType: DTO.accountReceiptPaymentType,
    }

    const data = {
      Data: payload,
      Url: 'endcustomer/pending_payment'
    }

    return this._http.post(`${this.proxyUrl}/service`, data)
  }

  public getPendingPayment(LeadEntityID: any) {
    return this._http.get(`${this.proxyUrl}/service?url=endcustomer/leads/${LeadEntityID}/pending_payments`)
  }

  public generatePaymentLinks(EntityAccountReceiptID: IPendingPaymentDTO, redirectURL: string) {
    return this._http.get(`${this.proxyUrl}/service?url=` + encodeURIComponent((`entityaccountreceipts/${EntityAccountReceiptID}/generate_payment_links`) + '?redirectUrl=' + redirectURL))
  }
  
  // ---------------------------------------------------------- //
  // ======================== Upload Files =====================//
  // ---------------------------------------------------------- //
  public uploadFile(file: any) {
    return this._http.post(`${this.integrationUrl}/file/upload`, file)
  }

  public attachment(file: Attachment) {
    const data = {
      data:{
        ...file
      },
      Url: `attachments`
    }
    return this._http.post(`${this.proxyUrl}/service/`, data)
  }

  
  public getAllAttachments(entityId: number) {
    return this._http.get(`${this.proxyUrl}/service?url=attachments/forentity/${entityId}`);
  }

  // ---------------------------------------------------------- //
  // ======================= Channel Partner ===================//
  // ---------------------------------------------------------- //
  public channelPartnerOrder(leadID: number, detailsUpdated: boolean) {
    const data = {
      Data: {
        LeadId: leadID,
        PasswordReset: true,
        detailsUpdated
      },
      Url: `channelpartnerorders/${leadID}`
    }
    return this._http.put(`${this.proxyUrl}/service`, data)
  }

  public createChannelPartnerOrder(
    LeadEntityID: number,
    emailVerificationToken: string,
    emailVerified: boolean,
    leadRegistrationToken: string,
    passwordReset: boolean,
    passwordResetToken: string,
    userName: string) {

    const data = {
      Data: {
        LeadId: LeadEntityID,
        EmailVerificationToken: emailVerificationToken,
        EmailVerified: emailVerified,
        LeadRegistrationToken: leadRegistrationToken,
        PasswordReset: passwordReset,
        PasswordResetToken: passwordResetToken,
        UserName: userName
      },
      Url: 'channelpartnerorders/' + LeadEntityID
    }

    return this._http.post(`${this.proxyUrl}/service`, data)
  }

  public getChannelPartnerOrder(LeadEntityID: number) {
    return this._http.get(`${this.proxyUrl}/service?url=channelpartnerorders/${LeadEntityID}`)
  }


// ---------------------------------------------------------- //
  // ====================Complaints========================//
  // ---------------------------------------------------------- //
  public emailComplaint(formValue: any, file?: File){
    
    const formData = new FormData();
    const model =  formValue;
    if(file) {
      formData.append('file', file);
    }
    formData.append("model", JSON.stringify(model))

    return this._http.put(`${this.integrationUrl}/notification/complaint/email`, formData)
  }

  /* -------------------------------------------------------------------------- */
  /*                              Duplicate Orders                              */
  /* -------------------------------------------------------------------------- */

  public checkForDuplicateOrderById(LeadEntityID: number) {
    return this._http.get(`${this.integrationUrl}/lead/${LeadEntityID}/checkforduplicate`)
  }

  public checkCustomerDuplicateOrderById(LeadEntityID: number) {
    return this._http.get(`${this.integrationUrl}/endcustomer/lead/${LeadEntityID}/checkforduplicate`)
  }

  public getDuplicateOrderReasons(LeadEntityID: number) {
    return this._http.get(`${this.integrationUrl}/duplicateorderreasons/${LeadEntityID}/list`)
  }

  public updateDuplicateOrderReason(LeadEntityID: number, duplicateOrderNotes: string, duplicateOrderReasonID: number) {
    const body = {
      DuplicateOrderNotes: duplicateOrderNotes,
      DuplicateOrderReasonID: duplicateOrderReasonID
    }

    return this._http.put(`${this.integrationUrl}/lead/${LeadEntityID}/duplicateorder`, body)
  }

}
